module.exports = __webpack_public_path__ + "static/img/weather26.3df72cf7.png";